import { createIcon } from '../createIcon';

export const DownLeftAndUpRightToCenterIconConfig = {
  name: 'DownLeftAndUpRightToCenterIcon',
  height: 512,
  width: 512,
  svgPath: 'M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z',
  yOffset: 0,
  xOffset: 0
};

export const DownLeftAndUpRightToCenterIcon = createIcon(DownLeftAndUpRightToCenterIconConfig);

export default DownLeftAndUpRightToCenterIcon;